export default "__VITE_ASSET__B7o3_n_B__"